import {useGetPersonQuery} from 'src/redux/queries/personnel';

export interface usePersonProps {
  value?: number;
}
export const usePerson = ({value}: usePersonProps) => {
  const {data, isLoading, isFetching} = useGetPersonQuery(value!, {
    skip: !value,
  });
  const subject =
    isLoading || isFetching ? 'Loading...' : data?.name ?? 'Unknown';

  const department = data?.department
    ? `${data?.department?.code} - ${data?.department?.description}`
    : 'None';
  const supervisor = data?.supervisor?.name ?? 'None';
  const id = data?.employeeId ?? 'No Employee ID';

  const description =
    isLoading || isFetching || !value
      ? ''
      : `${id} | Supervisor: ${supervisor} | Department: ${department}`;

  return {
    subject: subject,
    description: description,
    name: data?.name ?? null,
  };
};
